module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_99shopping.c4ba6641.pdf";